import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function PrivacyPage() {
  const pa = usePracticeArea('privacy');
  return <PracticeAreaTemplate pa={pa} />;
}
